import { render } from "./designCheckboxPrint.vue?vue&type=template&id=a57f70da"
import script from "./designCheckboxPrint.vue?vue&type=script&lang=js"
export * from "./designCheckboxPrint.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__